// extracted by mini-css-extract-plugin
export var checkboxLabel = "sorting-colors-module--checkbox-label--3DoFP";
export var colorBox = "sorting-colors-module--color-box--32std";
export var colorsList = "sorting-colors-module--colors-list--2yxic";